(() => {
  const context = document.querySelector('[data-breadcrumb-context]');
  if (!context) return;
  const storageKey = 'ashelly-shopping-origin';
  const productPath = (url) => url.pathname.match(/\/products\/[^/]+$/)?.[0];

  const rememberOrigin = (event) => {
    if (!['collection', 'search'].includes(context.dataset.pageType)) return;
    const link = event.target.closest('a[href]');
    if (!link || !link.closest('#MainContent')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !productPath(destination)) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        product: productPath(destination),
        source: location.href,
        title: context.dataset.sourceTitle,
        savedAt: Date.now()
      }));
    } catch {}
  };

  document.addEventListener('click', rememberOrigin);
  document.addEventListener('auxclick', (event) => {
    if (event.button === 1) rememberOrigin(event);
  });

  const restoreOrigin = () => {
    const back = context.querySelector('[data-shopping-return]');
    if (!back) return;
    back.hidden = true;
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (!saved || saved.product !== productPath(new URL(location.href))) return;
      if (Date.now() - saved.savedAt > 30 * 60 * 1000 || Date.now() < saved.savedAt) return;
      const source = new URL(saved.source);
      const referrer = new URL(document.referrer);
      if (source.origin !== location.origin || referrer.origin !== location.origin) return;
      if (!/\/(collections\/[^/]+|search)\/?$/.test(source.pathname)) return;
      if (referrer.pathname !== source.pathname) return;
      back.href = source.href;
      back.textContent = context.dataset.returnLabel.replace('[title]', saved.title);
      back.hidden = false;
    } catch {}
  };

  restoreOrigin();
  window.addEventListener('pageshow', restoreOrigin);
})();
